import React, { Component } from "react";
import { connect } from "react-redux";
import STRINGS from "../Constants/Strings";
import AuthBody from "../Components/Common/AuthBody/AuthBody";
import Stepper from "../Components/Common/Stepper/Stepper";
import { Card, CardGroup, Row, Col, Table, Button } from "react-bootstrap";
import { toDate } from "date-fns";
import moment from "moment";
import MembersScreen from "./MembersScreen";
import SidebarMenu from "./SidebarMenu";
import {
  S_CURRENT_BRANCH_ACTIVE_MENU,
  S_CURRENT_MEMBER_ID,
  S_CURRENT_MEMBER_IN_MARKETPLACE,
} from "../Communication/Constants";
import { removeBranchIdentifiers } from "../Utils/CommonUtilities";

/**
 * SINGLE SOURCE OF TRUTH FOR SEARCH STATE
 * Keeps all inputs controlled at all times
 */
const initialSearchState = {
  firstName: "",
  middleName: "",
  lastName: "",
  dob: "",
  sin4: "",
  pan: "",
  memberNumber: "",
  mobile: "",
  home: "",
  email: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  country: "CAN",
};

export class BranchDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu:
        sessionStorage.getItem(S_CURRENT_BRANCH_ACTIVE_MENU) || "dashboard",
      membersTab: "personal",
      personalTab: "members",
      search: { ...initialSearchState },
      memberAutoLoad: null,
      // Stub data for recent members
      recentMembers: [
        {
          name: "Mateo Rodriguez",
          avatar: "https://randomuser.me/api/portraits/men/32.jpg",
          action: "Check Deposit",
          transaction: "Transaction ID: 00623087724",
        },
        {
          name: "Ajay Hans",
          avatar: "https://randomuser.me/api/portraits/men/33.jpg",
          action: "Appointment request",
          transaction: "RE: Mutual Funds",
        },
        {
          name: "Juan Guterez",
          avatar: "https://randomuser.me/api/portraits/men/34.jpg",
          action: "Cash Withdrawal",
          transaction: "Transaction ID: 00623087684",
        },
        {
          name: "Fatima Diop",
          avatar: "https://randomuser.me/api/portraits/women/35.jpg",
          action: "Mortgage Renewal",
          transaction: "LOS-98157902",
        },
        {
          name: "Jane Doe",
          avatar: "https://randomuser.me/api/portraits/women/35.jpg",
          action: "Personal Loan",
          transaction: "LOS-2223346",
        },
      ],
    };
  }

  componentDidMount() {
    console.log(
      "componentDidMount",
      sessionStorage.getItem(S_CURRENT_MEMBER_ID),
      sessionStorage.getItem(S_CURRENT_MEMBER_IN_MARKETPLACE)
    );
    const { doGetGlobalVault, doResetApplication, history } = this.props;
    if (
      !!sessionStorage.getItem(S_CURRENT_MEMBER_IN_MARKETPLACE) &&
      !!sessionStorage.getItem(S_CURRENT_MEMBER_ID)
    ) {
      this.setState({
        activeMenu: "members",
        memberAutoLoad: sessionStorage.getItem(S_CURRENT_MEMBER_ID),
      });
      sessionStorage.setItem(S_CURRENT_BRANCH_ACTIVE_MENU, "members");
      sessionStorage.removeItem(S_CURRENT_MEMBER_IN_MARKETPLACE);
      return;
    }

    removeBranchIdentifiers();
    doResetApplication();
    doGetGlobalVault({ vaultKey: "dashboard" });

    // Check for tab query parameter and set activeMenu accordingly
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");
    if (tabParam === "members") {
      this.setState({ activeMenu: "members" });
      sessionStorage.setItem(S_CURRENT_BRANCH_ACTIVE_MENU, "members");
    }
    const idParam = urlParams.get("id");
    if (idParam) {
      this.setState({ memberAutoLoad: idParam });
    }
  }

  componentDidUpdate() {
    console.log("componentDidUpdate");
  }

  componentWillUnmount() {}

  handleMenuClick = (menu, tabConfig = {}) => {
    console.log("menu", menu, tabConfig);
    const { updateMemberName, dispatch } = this.props;

    const newState = {
      activeMenu: menu,
      memberAutoLoad: null,
      search: { ...initialSearchState },
    };

    if (menu === "members") {
      newState.membersTab = tabConfig.primaryTab || "personal";
      newState.personalTab = tabConfig.secondaryTab || "members";

      // Clear URL parameters when navigating to Members from another menu
      // This ensures we return to the default Member Search view
      if (window.history && window.history.pushState) {
        const currentUrl = new URL(window.location.href);
        const newUrl = `${currentUrl.pathname}`;
        window.history.pushState({ path: newUrl }, "", newUrl);
      }
    }

    this.setState(newState);
    updateMemberName(null);
    sessionStorage.setItem(S_CURRENT_BRANCH_ACTIVE_MENU, menu);
    removeBranchIdentifiers(dispatch);
  };

  handleTabClick = (tab) => {
    this.setState({
      membersTab: tab,
      search: { ...initialSearchState },
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      search: { ...prev.search, [name]: value },
    }));
  };

  handleSearch = (e) => {
    e.preventDefault();
    // For now, always return no results for stub
  };

  handleResetSearch = () => {
    this.setState({
      search: { ...initialSearchState },
    });
  };

  render() {
    const {
      activeMenu,
      membersTab,
      search,
      recentMembers,
      memberAutoLoad,
    } = this.state;

    const {
      history,
      proceedWithApplication,
      productList,
      updateMemberName: doUpdateMemberName,
      switchBanking,
      provinceList,
      doSetInSessionJointApplicant,
      doAccountSearch,
      doApplicationSearch,
      doUpdateApplicant,
      doDeleteApplication,
      doUpdateProductToVault,
      doFileList,
      doUploadFile,
      doAddDocument,
      doDeleteDocument,
      doGetDocumentList,
      doGetDocument,
      doGetApplicationProperty,
      employmentAndIncomeReducer,
      occupationCodes,
      idTypes,
      finInfo,
      doAccountCreate,
      complianceReducer,
      doGetProductInformation,
      doGetApplicationNotes,
      doUpdateApplicationNotesReview,
      doConfirmApp,
      doGetProductFromVault,
      doGetVault,
    } = this.props;

    if (activeMenu === "members") {
      return (
        <MembersScreen
          membersTab={membersTab}
          personalTab={this.state.personalTab}
          setMembersTab={(tab) => this.setState({ membersTab: tab })}
          setPersonalTab={(tab) => this.setState({ personalTab: tab })}
          search={search}
          recentMembers={recentMembers}
          handleTabClick={this.handleTabClick}
          handleInputChange={this.handleInputChange}
          handleSearch={this.handleSearch}
          handleResetSearch={this.handleResetSearch}
          activeMenu={activeMenu}
          onMenuClick={this.handleMenuClick}
          history={history}
          proceedWithApplication={proceedWithApplication}
          productList={productList}
          updateMemberName={doUpdateMemberName}
          memberAutoLoad={memberAutoLoad}
          switchBanking={switchBanking}
          provinceList={provinceList}
          doSetInSessionJointApplicant={doSetInSessionJointApplicant}
          doAccountSearch={doAccountSearch}
          doApplicationSearch={doApplicationSearch}
          doUpdateApplicant={doUpdateApplicant}
          doDeleteApplication={doDeleteApplication}
          doUpdateProductToVault={doUpdateProductToVault}
          doFileList={doFileList}
          doUploadFile={doUploadFile}
          doAddDocument={doAddDocument}
          doDeleteDocument={doDeleteDocument}
          doGetDocumentList={doGetDocumentList}
          doGetDocument={doGetDocument}
          doGetApplicationProperty={doGetApplicationProperty}
          employmentAndIncomeReducer={employmentAndIncomeReducer}
          occupationCodes={occupationCodes}
          idTypes={idTypes}
          finInfo={finInfo}
          doAccountCreate={doAccountCreate}
          complianceReducer={complianceReducer}
          doGetProductInformation={doGetProductInformation}
          doGetApplicationNotes={doGetApplicationNotes}
          doUpdateApplicationNotesReview={doUpdateApplicationNotesReview}
          doConfirmApp={doConfirmApp}
          doGetProductFromVault={doGetProductFromVault}
          doGetVault={doGetVault}
        />
      );
    }
    // Default: show the original dashboard (existing code)
    return (
      <div className="[ branch-wrapper ]">
        <div className="[ container ] [ pb-3 ] [ main-container ]">
          <div className="[ row ] [ main-container__body ]">
            <div className="col-xl-2 col-lg-3 col-md-3 col-12">
              <SidebarMenu
                activeMenu={activeMenu}
                onMenuClick={this.handleMenuClick}
              />
            </div>
            <div className="[ col-xl-10 col-lg-9 col-md-9 col-12 ][ main-container__body ]">
              <div className="[ row ]">
                {/* BEGIN - CALENDAR WIDGET */}
                <div className="[ col-xl-4 col-lg-12 ]">
                  <section
                    className="branch-widget branch-widget--calendar"
                    aria-labelledby="calendar-section-title"
                  >
                    <Card className="branch-widget__card">
                      <Card.Header
                        className="branch-widget__header"
                        role="heading"
                        aria-level="2"
                      >
                        <div className="branch-widget__header-left">
                          <i
                            className="fas fa-calendar-day branch-widget__icon"
                            aria-hidden="true"
                          ></i>
                          <h2
                            id="calendar-section-title"
                            className="branch-widget__title"
                          >
                            {STRINGS.BRANCH.DASHBOARD.CALENDAR_TITLE}
                          </h2>
                        </div>
                        <div className="branch-widget__header-right">
                          <button
                            type="button"
                            className="branch-widget__action"
                            aria-label="Open Calendar section"
                          >
                            <i
                              className="fas fa-external-link-alt"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row className="branch-widget__subheader">
                          <div className="branch-widget__subheader-text">
                            Today, {moment().format("MMMM D, YYYY")}
                          </div>
                        </Row>

                        <div className="branch-widget__table-preview">
                          <Table
                            striped
                            hover
                            size="sm"
                            responsive
                            className="branch-widget__table"
                          >
                            <tbody>
                              <tr>
                                <td>Now</td>
                                <td>Departmental Meeting</td>
                              </tr>
                              <tr>
                                <td>9:00</td>
                                <td>Meeting with Ajay</td>
                              </tr>
                              <tr>
                                <td>12:00</td>
                                <td>Meeting with Client</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Card.Body>
                    </Card>
                  </section>
                </div>

                {/* BEGIN - REPORTS WIDGET */}
                <div className="[ col-xl-4 col-lg-12 ]">
                  <section
                    className="branch-widget branch-widget--reports"
                    aria-labelledby="reports-section-title"
                  >
                    <Card className="branch-widget__card">
                      <Card.Header className="branch-widget__header">
                        <div className="branch-widget__header-left">
                          <i
                            className="fas fa-chart-area branch-widget__icon"
                            aria-hidden="true"
                          ></i>
                          <h2
                            id="reports-section-title"
                            className="branch-widget__title"
                          >
                            {STRINGS.BRANCH.DASHBOARD.REPORTS_TITLE}
                          </h2>
                        </div>
                        <div className="branch-widget__header-right">
                          <button
                            type="button"
                            className="branch-widget__action"
                            aria-label="Open Reports section"
                          >
                            <i
                              className="fas fa-external-link-alt"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row className="branch-widget__subheader">
                          <div className="branch-widget__subheader-text">
                            Today
                          </div>
                        </Row>

                        <div className="branch-widget--reports__metrics">
                          <div className="branch-widget--reports__metric branch-widget--reports__metric--neutral">
                            <div className="branch-widget--reports__metric-label">
                              Metric
                            </div>
                            <div className="branch-widget--reports__metric-value">
                              21
                            </div>
                          </div>

                          <div className="branch-widget--reports__metric branch-widget--reports__metric--positive">
                            <div className="branch-widget--reports__metric-label">
                              Metric
                            </div>
                            <div className="branch-widget--reports__metric-value">
                              12
                            </div>
                          </div>

                          <div className="branch-widget--reports__metric branch-widget--reports__metric--chart">
                            <div className="branch-widget--reports__metric-label">
                              Metric
                            </div>
                            <svg width="48" height="28" viewBox="0 0 48 28">
                              <rect
                                x="2"
                                y="20"
                                width="8"
                                height="6"
                                fill="#357ae8"
                              />
                              <rect
                                x="12"
                                y="16"
                                width="8"
                                height="10"
                                fill="#357ae8"
                              />
                              <rect
                                x="22"
                                y="8"
                                width="8"
                                height="18"
                                fill="#357ae8"
                              />
                              <rect
                                x="32"
                                y="18"
                                width="8"
                                height="8"
                                fill="#357ae8"
                              />
                            </svg>
                          </div>

                          <div className="branch-widget--reports__metric branch-widget--reports__metric--pie">
                            <div className="branch-widget--reports__metric-label">
                              Metric
                            </div>
                            <svg width="40" height="40" viewBox="0 0 40 40">
                              <circle cx="20" cy="20" r="16" fill="#e6f7e6" />
                              <path
                                d="M20 4 a 16 16 0 1 1 -11.31 27.31"
                                fill="none"
                                stroke="#f7931a"
                                strokeWidth="6"
                                strokeLinecap="round"
                              />
                              <circle cx="20" cy="20" r="12" fill="#fff" />
                            </svg>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </section>
                </div>

                {/* BEGIN - ALERTS WIDGET */}
                <div className="[ col-xl-4 col-lg-12 ]">
                  <section
                    className="branch-widget branch-widget--alerts"
                    aria-labelledby="alerts-section-title"
                  >
                    <Card className="branch-widget__card">
                      <Card.Header className="branch-widget__header">
                        <div className="branch-widget__header-left">
                          <i
                            className="fas fa-bell branch-widget__icon"
                            aria-hidden="true"
                          ></i>
                          <h2
                            id="alerts-section-title"
                            className="branch-widget__title"
                          >
                            {STRINGS.BRANCH.DASHBOARD.ALERTS_TITLE}
                          </h2>
                        </div>
                        <div className="branch-widget__header-right">
                          <button
                            type="button"
                            className="branch-widget__action"
                            aria-label="Open Alerts section"
                          >
                            <i
                              className="fas fa-external-link-alt"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row className="branch-widget__subheader">
                          <div className="branch-widget__subheader-text">
                            Latest Alert - {moment().format("MMMM D, YYYY")}
                          </div>
                        </Row>

                        <Row className="branch-widget__body">
                          <Col
                            xs={12}
                            className="branch-widget__body-text branch-widget--alerts__alert-status in-review"
                          >
                            IN REVIEW
                          </Col>
                          <Col
                            xs={12}
                            className="branch-widget__body-text branch-widget--alerts__alert-line"
                          >
                            Application ID: AOS-2342343
                          </Col>
                          <Col
                            xs={12}
                            className="branch-widget__body-text branch-widget--alerts__alert-line"
                          >
                            RE: Failed Reason Code Review
                          </Col>
                          <Col
                            xs={12}
                            className="branch-widget__body-link branch-widget--alerts__alert-link"
                          >
                            <a href="#">
                              {STRINGS.BRANCH.BUTTONS.LINK_SEE_DETAILS}
                              <i
                                className="fas fa-arrow-right"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </section>
                </div>
              </div>

              {/* BEGIN - STAFF ACTIVITIES WIDGET */}
              <div className="[ row ]">
                <div className="[ col-xl-12 col-lg-12 ]">
                  <section
                    className="branch-widget branch-widget--activity"
                    aria-labelledby="activity-section-title"
                  >
                    <Card className="branch-widget__card">
                      <Card.Header className="branch-widget__header">
                        <div className="branch-widget__header-left">
                          <i
                            className="fas fa-user-clock branch-widget__icon"
                            aria-hidden="true"
                          ></i>
                          <h2
                            id="activity-section-title"
                            className="branch-widget__title"
                          >
                            {STRINGS.BRANCH.DASHBOARD.ACTIVITY_TITLE}
                          </h2>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <div className="branch-widget__subheader">
                          <div className="branch-widget__subheader-text"></div>
                        </div>
                        <div className="branch-widget__subheader row">
                          <div className="[ branch-tab-container ]">
                            <ul className="[ nav nav-tabs w-100 d-flex ]">
                              <li
                                className="[ nav-item flex-fill text-center ]"
                                // key={"staff-activity"}
                              >
                                <button
                                  type="button"
                                  className={"form-subtitle nav-link active"}
                                  // className={
                                  //   staffActivityTab === "staff-activity"
                                  //     ? "[ form-subtitle nav-link active ]"
                                  //     : "[ form-subtitle nav-link inactive ]"
                                  // }
                                  data-toggle="tab"
                                  role="tab"
                                  // aria-controls={"staff-activity"}
                                  // onClick={() => setStaffActivityTab("staff-activity")}
                                >
                                  {
                                    STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABS
                                      .RECENT
                                  }
                                </button>
                                <div
                                  className={"tab-line"}
                                  // className={staffActivityTab === "staff-activity" ? "[ tab-line ]" : ""}
                                ></div>
                              </li>
                              <li
                                className="[ nav-item flex-fill text-center ]"
                                // key={"staff-tasks"}
                              >
                                <button
                                  type="button"
                                  className={"form-subtitle nav-link inactive"}
                                  // className={
                                  //   staffActivityTab === "staff-tasks"
                                  //     ? "[ form-subtitle nav-link active ]"
                                  //     : "[ form-subtitle nav-link inactive ]"
                                  // }
                                  data-toggle="tab"
                                  role="tab"
                                  // aria-controls={"staff-tasks"}
                                  // onClick={() => setStaffActivityTab("staff-tasks")}
                                >
                                  {STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABS.TASKS}
                                </button>
                                <div
                                  className={""}
                                  // className={
                                  //   staffActivityTab === "staff-tasks" ? "[ tab-line ]" : ""
                                  // }
                                ></div>
                              </li>
                              <li
                                className="[ nav-item flex-fill text-center ]"
                                // key={"staff-leads"}
                              >
                                <button
                                  type="button"
                                  className={"form-subtitle nav-link inactive"}
                                  // className={
                                  //   staffActivityTab === "staff-leads"
                                  //     ? "[ form-subtitle nav-link active ]"
                                  //     : "[ form-subtitle nav-link inactive ]"
                                  // }
                                  data-toggle="tab"
                                  role="tab"
                                  // aria-controls={"staff-leads"}
                                  // onClick={() => setStaffActivityTab("staff-leads")}
                                >
                                  {STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABS.LEADS}
                                </button>
                                <div
                                  className={""}
                                  // className={
                                  //   staffActivityTab === "staff-leads" ? "[ tab-line ]" : ""
                                  // }
                                ></div>
                              </li>
                            </ul>
                          </div>
                        </div>

                        {/* Subheader / Table Header */}
                        <div className="branch-widget__table-header mb-3">
                          <div className="row">
                            <div className="[ col-12 ] [ d-flex justify-content-between align-items-center flex-wrap ]">
                              <span
                                className="branch-widget__table-title"
                                aria-live="polite"
                              >
                                {
                                  STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                    .DISPLAYING_TITLE
                                }
                              </span>
                              <Button
                                variant="light"
                                size="sm"
                                className="branch-widget__refresh branch-widget__refresh--icon"
                                aria-label={
                                  STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                    .BUTTONS.REFRESH_ARIA_LABEL
                                }
                                // onClick={onRefresh}
                              >
                                <i
                                  className="fas fa-sync"
                                  aria-hidden="true"
                                ></i>
                              </Button>
                            </div>
                          </div>
                        </div>

                        {/* Pagination - static visual only */}
                        <div className="branch-widget__pagination d-flex align-items-center justify-content-between">
                          <div className="branch-widget__pagination-left d-flex align-items-center">
                            <label
                              htmlFor="itemsPerPage"
                              className="branch-widget__pagination-label"
                            >
                              Items per page:
                            </label>
                            <select
                              id="itemsPerPage"
                              className="branch-widget__pagination-select form-select form-select-sm"
                              defaultValue="20"
                            >
                              <option value="20">20</option>
                              <option value="40">40</option>
                            </select>
                          </div>

                          <div className="branch-widget__pagination-right d-flex align-items-center">
                            <label
                              htmlFor="pageSelect"
                              className="branch-widget__pagination-label"
                            >
                              Page:
                            </label>
                            <select
                              id="pageSelect"
                              className="branch-widget__pagination-select form-select form-select-sm"
                              defaultValue="1"
                            >
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                            </select>

                            <span className="branch-widget__pagination-info">
                              of 3
                            </span>

                            <Button
                              variant="outline-secondary"
                              size="sm"
                              aria-label="Previous page"
                              className="branch-widget__pagination-btn"
                              disabled
                            >
                              <i
                                className="fas fa-chevron-left"
                                aria-hidden="true"
                              ></i>
                            </Button>

                            <Button
                              variant="outline-secondary"
                              size="sm"
                              aria-label="Next page"
                              className="branch-widget__pagination-btn"
                            >
                              <i
                                className="fas fa-chevron-right"
                                aria-hidden="true"
                              ></i>
                            </Button>
                          </div>
                        </div>
                        <Row>
                          <Col xs={12}>
                            <Table
                              striped
                              hover
                              size="sm"
                              responsive
                              className="branch-widget__table"
                            >
                              <thead>
                                <tr>
                                  <th>
                                    {
                                      STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                        .HEADERS.ACTIVITY
                                    }
                                  </th>
                                  <th>
                                    {
                                      STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                        .HEADERS.PRODUCT_CODE
                                    }
                                  </th>
                                  <th>
                                    {
                                      STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                        .HEADERS.APPLICATION_ID
                                    }
                                  </th>
                                  <th>
                                    {
                                      STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                        .HEADERS.TRANSACTION
                                    }
                                  </th>
                                  <th>
                                    {
                                      STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                        .HEADERS.TIME_DATE
                                    }
                                  </th>
                                  <th>
                                    {
                                      STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                        .HEADERS.QUICK_VIEW
                                    }
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Cheque Deposit</td>
                                  <td>1013</td>
                                  <td>-</td>
                                  <td>TRN-345345345</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Cash Withdrawal</td>
                                  <td>1012</td>
                                  <td>-</td>
                                  <td>TRN-563465465</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Member Onboard</td>
                                  <td>2345</td>
                                  <td>AOS-2342343</td>
                                  <td>-</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Lending Application</td>
                                  <td>4558</td>
                                  <td>LOS-3654334</td>
                                  <td>-</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Mortgage Renewal</td>
                                  <td>6543</td>
                                  <td>LOS-1231232</td>
                                  <td>-</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Cheque Deposit</td>
                                  <td>1513</td>
                                  <td>-</td>
                                  <td>TRN-453453454</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Cash Withdrawal</td>
                                  <td>1182</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      See Details
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Member Onboard</td>
                                  <td>3345</td>
                                  <td>AOS-2342383</td>
                                  <td>-</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Lending Application</td>
                                  <td>4558</td>
                                  <td>LOS-3854334</td>
                                  <td>-</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Mortgage Renewal</td>
                                  <td>6543</td>
                                  <td>LOS-1831232</td>
                                  <td>-</td>
                                  <td>12:27:15PM - 03/11/2025</td>
                                  <td className="branch-widget__body-link">
                                    <a href="#">
                                      {
                                        STRINGS.BRANCH.DASHBOARD.ACTIVITY_TABLE
                                          .LINK_DETAILS
                                      }
                                      <i
                                        className="fas fa-arrow-right"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

BranchDashboard.propTypes = {};

BranchDashboard.defaultProps = {};

export default connect(mapStateToProps, {})(BranchDashboard);
